import React from "react";
import { Select, SelectOption } from "@showitinc/showit-wc";
import { FILL_TYPE_COLOR, FILL_TYPE_GRADIENT, FILL_SELECTION_ADVANCED } from "@/constants/SyncConstants";
import Input from "@/app2components/base/Input";
import { COLOR_PICKER } from "@/constants/InputConstants.mjs";
import LeftOffset from "@/components/base/LeftOffset";
import { hasBackdropFilter } from "@/utils/Element/FilterUtils";

/**
 * Displays fillType input and child props
 * @param {Object} props
 * @param {string} [props.colorShift="left"] - Direction for color picker flyout positioning
 * @param {boolean} [props.showAdvancedFill=true] - When false, Advanced option is hidden (e.g. for buttons)
 * @returns {import("react").ReactElement}
 */
const FillTypeProperties = (props) => {
  const { value: fillType, isLocked, subProps = {}, onSIChange, colorShift = "left", showAdvancedFill = true } = props;

  return (
    <>
      <Select disabled={isLocked} {...props} onSISelect={onSIChange}>
        <SelectOption value={FILL_TYPE_COLOR}>Color</SelectOption>
        <SelectOption value={FILL_TYPE_GRADIENT}>Gradient</SelectOption>
        {showAdvancedFill && (
          <SelectOption value={FILL_SELECTION_ADVANCED}>Advanced</SelectOption>
        )}
      </Select>
      {fillType === FILL_TYPE_COLOR && (
        <LeftOffset>
          <Input
            inputType={COLOR_PICKER}
            color={subProps?.bgcolor?.value}
            shift={colorShift}
            disabled={isLocked}
            {...subProps?.bgcolor}
          />
        </LeftOffset>
      )}
      {fillType === FILL_TYPE_GRADIENT && (
        <LeftOffset>
          <Input
            inputType={COLOR_PICKER}
            color={subProps?.gc1?.value}
            shift={colorShift}
            disabled={isLocked}
            {...subProps?.gc1}
          />
          <Input
            inputType={COLOR_PICKER}
            color={subProps?.gc2?.value}
            shift={colorShift}
            disabled={isLocked}
            {...subProps?.gc2}
          />
          <Input disabled={isLocked} {...subProps?.gr} />
        </LeftOffset>
      )}
      {fillType === FILL_TYPE_COLOR && hasBackdropFilter(subProps?.backdropFilter?.value) && (
        <LeftOffset>
          <Input
            inputType={COLOR_PICKER}
            color={subProps?.bgcolor?.value}
            shift={colorShift}
            disabled={isLocked}
            {...subProps?.bgcolor}
          />
        </LeftOffset>
      )}
    </>
  );
};

export default FillTypeProperties;
